import React from "react";
import UseCaseHeader from "components/UseCaseHeader";
import ServiceLogoGrid from "components/ServiceLogoGrid";
import { USE_CASES } from "utils/constants/useCases";
import IMAGES from "utils/constants/image";
import { VIDEO_SERVICES } from "utils/constants/useCases";
import { styles } from "./styles";

const COPY_PRIMARY =
  "The world now meets online, leveraging video to collaborate and communicate remotely. Payment links can help companies sell directly to their customers over video.";
const COPY_SECONDARY =
  "Whether you're a sales executive running through a product demo remotely or a business owner hosting a remote workshop, payment links can help you convert sales directly from where you're engaging with your customers.";

const Video = () => {
  const compatibleWith = (
    <div className="w-100 pt3">
      <div className="f6 black-50 pb2 pb0-l">Compatible with</div>
      <ServiceLogoGrid services={Object.values(VIDEO_SERVICES)}>
        <div className="f5">+ more</div>
      </ServiceLogoGrid>
    </div>
  );

  return (
    <section className="w-100">
      <div className="w-100 w-50-ns fl">
        <UseCaseHeader type={USE_CASES.VIDEO} />
        <div className="f5 f4-l fw4 mb3 mt0-ns tl lh-copy pt2 pt4-l">
          {COPY_PRIMARY}
        </div>
        <div className="dn dib-ns">
          <div className="f5 f4-l fw4 mb3 mt0-ns tl lh-copy pt2 dn dib-ns">
            {COPY_SECONDARY}
          </div>
          {compatibleWith}
        </div>
      </div>
      <div className="w-100 w-50-ns fr mv3 mv0-ns">
        <div className={`${IMAGES.USE_CASE_VIDEO}--wrapper`}>
          <div className={`${IMAGES.USE_CASE_VIDEO}--img contain contain`} />
        </div>
        <div className="w-100 dn-ns dib">
          <div className="f5 f4-l fw4 mb3 mt3 mt0-ns tl lh-copy pt2">
            {COPY_SECONDARY}
          </div>
          {compatibleWith}
        </div>
      </div>
      <style jsx>{styles}</style>
    </section>
  );
};
export default Video;
